import { TEMPLATE_CATEGORIES_SUFFIXES } from '../../constants/templates.constants';
import DossierTemplates from '../../containers/dossier-templates/DossierTemplates';
import { getTemplateCategory } from '../../lib/template.utils';
import AttachmentsList from '../attachments/AttachmentsList';

const DossierClarificationAttachments = ({
  loadingAttachments,
  dossierType,
  attachments = [],
  read,
  write,
  onAttachmentAdd,
  onAttachmentOpen
}) => {
  if (!read) {
    return null;
  }

  return (
    <AttachmentsList
      className={'spo-o-dossier-clarification-attachments'}
      title="Bestanden"
      attachments={attachments}
      loading={loadingAttachments}
      noAttachmentsText="Er zijn momenteel nog geen bestanden toegevoegd."
      onOpen={onAttachmentOpen}
      onUpload={write ? onAttachmentAdd : undefined}
      templates={
        write && (
          <DossierTemplates category={getTemplateCategory(dossierType, TEMPLATE_CATEGORIES_SUFFIXES.CLARIFICATION)} />
        )
      }
    />
  );
};

export default DossierClarificationAttachments;
